import { useEffect, useRef, useState } from 'react';
import { Alert, Box, useMediaQuery } from '@mui/material';

let scriptPromise;
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = () => resolve(window.turnstile);
      script.onerror = () => { script.remove(); scriptPromise = null; reject(new Error('CAPTCHA nicht verfügbar.')); };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

export default function Turnstile({ onToken, attempt }) {
  const container = useRef(null);
  const [error, setError] = useState(false);
  const sitekey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  const compact = useMediaQuery('(max-width:400px)');
  useEffect(() => {
    if (!sitekey) return;
    let widget;
    let stopped = false;
    setError(false);
    onToken('');
    loadTurnstile().then(turnstile => {
      if (stopped) return;
      widget = turnstile.render(container.current, { sitekey, action: 'login', size: compact ? 'compact' : 'flexible',
        language: 'de', theme: 'auto', callback: onToken,
        'expired-callback': () => onToken(''), 'error-callback': () => { onToken(''); setError(true); } });
    }).catch(() => { if (!stopped) { onToken(''); setError(true); } });
    return () => { stopped = true; if (widget !== undefined) window.turnstile?.remove(widget); };
  }, [sitekey, onToken, attempt, compact]);
  return sitekey ? <Box><Box ref={container} sx={{ minHeight: compact ? 140 : 65, width: '100%' }} />
    {error && <Alert severity="error">CAPTCHA konnte nicht geprüft werden. Bitte die Seite neu laden.</Alert>}</Box>
    : <Alert severity="warning">Die CAPTCHA-Konfiguration fehlt. Eine Anmeldung ist noch nicht möglich.</Alert>;
}
